import { CreateRounded } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import moment from 'moment/moment'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
// import CustomChip from '../../../../../../components/common/admin/CustomChip'
import { IRootState } from '../../../../../../redux/types'
import ButtonBack from '../../../../../shared/components/buttons/ButtonBack'
import HiddenDesktop from '../../../../../shared/styles/HiddenDesktop'
import { isClient, isCommercial } from '../../../utils/RolesHelper'
import { AvatarMobile, EditButton, HeroContainer, StatusAvatar } from '../../styles/detail/MobileGeneralInfo'
import CustomVerifiedIcon from '../CustomVerifiedIcon'

interface MobileGeneralInfoProps {
  handleClickEdit: any
}

export function MobileGeneralInfo({ handleClickEdit }: MobileGeneralInfoProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  let userName = authUser ? authUser.name.split(' ') : import.meta.env.VITE_NAME
  let countWords = userName.length

  let textAvatar =
    countWords <= 1
      ? `${userName[0].charAt(0).toLocaleUpperCase()}`
      : ['(C)', '(Cc)'].includes(userName[0])
        ? `${userName[1].charAt(0).toLocaleUpperCase()}`
        : `${userName[0].charAt(0).toLocaleUpperCase()}${userName[1].charAt(0).toLocaleUpperCase()}`

  const roleId = userProfileSelected.role_id
  return (
    <HiddenDesktop>
      <HeroContainer>
        <ButtonBack />
      </HeroContainer>
      <Box>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'flex-end'} pb={1}>
          {/* Avatar user */}
          <Box style={{ position: 'relative' }}>
            <AvatarMobile>{textAvatar}</AvatarMobile>
            <StatusAvatar>
              {/*{userProfileSelected.status === 1 ? (*/}
              {/*  <CustomChip size="medium" type={1} color="primary" />*/}
              {/*) : (*/}
              {/*  <CustomChip size="medium" type={1} color="secondary" />*/}
              {/*)}*/}
            </StatusAvatar>
          </Box>
          <EditButton onClick={handleClickEdit} variant="contained" startIcon={<CreateRounded />}>
            {t('edit')}
          </EditButton>
        </Box>
        {/* Username & verify icon */}
        <Box display="flex" gap={4} alignItems={'center'}>
          <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
            {userProfileSelected.name}
          </Typography>
          <CustomVerifiedIcon value={userProfileSelected.verification} />
        </Box>
        <Box display={'flex'} justifyContent={'space-between'}>
          {/* Inner information, ID, Rol, Status */}
          <Box display="inline" alignContent={'center'} height={'fit-content'}>
            <Typography variant="body2" color="textSecondary">
              <b>ID:</b> {userProfileSelected.id}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <b>{t('rol')}:</b> {userProfileSelected.roleName}
            </Typography>
          </Box>
          <Box display={'inline'} textAlign={'end'}>
            <Typography variant="body2" color="textSecondary">
              {t('admin.people.last-login')}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {userProfileSelected.last_login_at === null ? 'Sin datos' : moment(userProfileSelected.last_login_at).format('l')}
            </Typography>
          </Box>
        </Box>

        {isCommercial(roleId) ||
          (isClient(roleId) && (
            <Box py={2}>
              {isCommercial(roleId) && (
                <Typography variant="body2" style={{ fontWeight: 400 }}>
                  Código comercial: <b>{userProfileSelected.commercial_code}</b>
                </Typography>
              )}
              {isClient(roleId) && userProfileSelected.center !== null && (
                <Typography variant="body2" style={{ fontWeight: 400 }}>
                  Centro: {userProfileSelected.center.name}
                </Typography>
              )}
            </Box>
          ))}
      </Box>
    </HiddenDesktop>
  )
}
